// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  // DialogContentText,
  // TextField,
  // // Tooltip,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
// import MDBadge from "theme/components/MDBadge";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";

// import Editor from "react-simple-wysiwyg";

function ChurnCustomers() {
  const pageTitle = "Customers";
  usePageTitle(pageTitle);

  const { id: reference } = useParams();

  // const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [openPaymentLinkDialog, setOpenPaymentLinkDialog] = useState(false);

  const [refreshPage, setRefreshPage] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [campaign, setCampaign] = useState({});

  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerEmail, setCustomerEmail] = useState(null);

  const [openCopySnackBar, setOpenSnackBar] = useState(false);
  async function copy(voucher) {
    try {
      await navigator.clipboard.writeText(voucher);
      setOpenSnackBar(true);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  }

  const tableColumns = [
    { Header: "Action", accessor: "action", align: "left" },
    { Header: "Customer", accessor: "customer", align: "left" },
    { Header: "Email", accessor: "email", align: "left" },
    { Header: "Phone", accessor: "phone", align: "left" },
    { Header: "Sent", accessor: "sent", align: "center" },
    { Header: "Paid", accessor: "paid", align: "center" },
    // { Header: "Status", accessor: "status", align: "center" },
    { Header: "Added On", accessor: "created", align: "center" },
  ];

  const buildRateRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        action: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="contained"
              color="success"
              iconOnly
              circular
              onClick={() => {
                if (row.paid) {
                  return;
                }
                setSelectedCustomer(row);
                setOpenPaymentLinkDialog(true);
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                send
              </Icon>
            </MDButton>
          </MDBox>
        ),
        customer: `${row.customer.last_name} ${row.customer.first_name}`,
        email: row.customer.email_address,
        phone: row.customer.phone_number,
        sent: (
          <MDBox>
            <Icon color={row.sent ? "success" : "error"}>
              {row.sent ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        paid: (
          <MDBox>
            <Icon color={row.paid ? "success" : "error"}>
              {row.paid ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        // status: (
        //   <MDBox>
        //     <Icon color={row.status ? "success" : "error"}>
        //       {row.status ? "check_circle" : "cancel"}
        //     </Icon>
        //   </MDBox>
        // ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/churn_campaigns/${reference}/customers.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCampaign(result.data.data.campaign);
            const rows = buildRateRows(result.data.data.customers);
            setCustomers(rows);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function sendPayLink() {
    setOpenPaymentLinkDialog(false);
    setShowLoading(true);
    const json = {
      reference: `${selectedCustomer.reference}`,
      email_address: customerEmail,
    };

    await axios
      .post("portal/churn_campaigns/customers/send_paylink.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {selectedCustomer ? (
        <Dialog open={openPaymentLinkDialog}>
          <DialogTitle>
            <MDBox>Send Payment Link</MDBox>
          </DialogTitle>
          <DialogContent>
            <MDBox mt={2} mb={3}>
              <MDBox mt={3}>
                <MDInput
                  placeholder="Email"
                  name="email"
                  margin="dense"
                  label="Email"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={selectedCustomer.customer.email_address}
                  onChange={(e) => setCustomerEmail(e.target.value)}
                />
              </MDBox>
              <MDBox mt={3} align="center">
                <MDBox>
                  <MDTypography variant="h6" fontWeight="light">
                    {selectedCustomer.payment_link}
                  </MDTypography>
                </MDBox>
                <MDBox mt={3}>
                  <MDButton
                    onClick={() => {
                      copy(selectedCustomer.payment_link);
                    }}
                    color="success"
                    variant="contained"
                    size="small"
                  >
                    <Icon>content_copy</Icon> &nbsp; Copy Pay Link
                  </MDButton>
                  <Snackbar
                    autoHideDuration={5000}
                    onClose={() => setOpenSnackBar(false)}
                    open={openCopySnackBar}
                  >
                    <Alert severity="success" sx={{ width: "100%" }}>
                      Copied
                    </Alert>
                  </Snackbar>
                </MDBox>
              </MDBox>
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenPaymentLinkDialog(false);
              }}
              color="dark"
              variant="outlined"
            >
              Cancel
            </MDButton>
            <MDButton
              color="success"
              variant="outlined"
              onClick={() => {
                sendPayLink();
              }}
            >
              Send Pay Link
            </MDButton>
          </DialogActions>
        </Dialog>
      ) : (
        <> </>
      )}

      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDBox
                        pt={2}
                        px={2}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <MDTypography variant="h6" fontWeight="medium">
                          Customers ({campaign.title})
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={5}>
                        <DataTable
                          table={{ columns: tableColumns, rows: customers }}
                          isSorted
                          entriesPerPage
                          showTotalEntries
                          buttons
                          noEndBorder
                        />
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ChurnCustomers;
